import { Q as e, _ as n, W as t, U as a, V as s, ac as r, aB as o, u as E, aP as N, n as i } from "./__bundle-75942676.js";
import { r as u, R as _, s as l } from "./__bundle-84f74e8d.js";
import { h as C } from "./__bundle-ad161b2c.js";
var d;
!function (e) {
  e[e.NONE = 0] = "NONE", e[e.CHANNEL_ENTER = 10102] = "CHANNEL_ENTER", e[e.CHANNEL_EXIT = 10103] = "CHANNEL_EXIT", e[e.USER_CHANNEL_MUTE = 10201] = "USER_CHANNEL_MUTE", e[e.USER_CHANNEL_UNMUTE = 10200] = "USER_CHANNEL_UNMUTE", e[e.USER_CHANNEL_BAN = 10601] = "USER_CHANNEL_BAN", e[e.USER_CHANNEL_UNBAN = 10600] = "USER_CHANNEL_UNBAN", e[e.CHANNEL_FREEZE = 10701] = "CHANNEL_FREEZE", e[e.CHANNEL_UNFREEZE = 10700] = "CHANNEL_UNFREEZE", e[e.TYPING_START = 10900] = "TYPING_START", e[e.TYPING_END = 10901] = "TYPING_END", e[e.CHANNEL_JOIN = 1e4] = "CHANNEL_JOIN", e[e.CHANNEL_LEAVE = 10001] = "CHANNEL_LEAVE", e[e.CHANNEL_OPERATOR_UPDATE = 10002] = "CHANNEL_OPERATOR_UPDATE", e[e.CHANNEL_INVITE = 10020] = "CHANNEL_INVITE", e[e.CHANNEL_ACCEPT_INVITE = 10021] = "CHANNEL_ACCEPT_INVITE", e[e.CHANNEL_DECLINE_INVITE = 10022] = "CHANNEL_DECLINE_INVITE", e[e.CHANNEL_PROP_CHANGED = 11e3] = "CHANNEL_PROP_CHANGED", e[e.CHANNEL_DELETED = 12e3] = "CHANNEL_DELETED", e[e.CHANNEL_META_DATA_CHANGED = 11100] = "CHANNEL_META_DATA_CHANGED", e[e.CHANNEL_META_COUNTERS_CHANGED = 11200] = "CHANNEL_META_COUNTERS_CHANGED", e[e.CHANNEL_HIDE = 13e3] = "CHANNEL_HIDE", e[e.CHANNEL_UNHIDE = 13001] = "CHANNEL_UNHIDE", e[e.PINNED_MESSAGE_CHANGED = 11300] = "PINNED_MESSAGE_CHANGED";
}(d || (d = {}));
var h = function () {
    function n(e) {
      var n;
      this.channelUrl = e.channel_url, this.channelType = e.channel_type, this.category = e.cat, this.data = null !== (n = e.data) && void 0 !== n ? n : {}, this.ts = e.ts;
    }
    return Object.defineProperty(n.prototype, "isGroupChannelEvent", {
      get: function get() {
        return this.channelType === e.GROUP;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "isOpenChannelEvent", {
      get: function get() {
        return this.channelType === e.OPEN;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(),
  A = function (e) {
    function t(n, t, a) {
      var s = e.call(this, n, "SYEV", a) || this;
      return s.event = new h(a), s;
    }
    return n(t, e), t;
  }(t),
  c = function (e) {
    function t(n, t, s) {
      var r = e.call(this, n, t, s) || this,
        o = s.data.operators,
        E = void 0 === o ? [] : o;
      return r.operators = E.map(function (e) {
        return new a(r._iid, e);
      }), r;
    }
    return n(t, e), t;
  }(A),
  p = function (e) {
    function t(n, t, a) {
      var s = e.call(this, n, "MCNT", a) || this;
      return s.groupChannelMemberCounts = a.group_channels.map(function (e) {
        return {
          channelUrl: e.channel_url,
          memberCount: e.member_count,
          joinedMemberCount: e.joined_member_count,
          updatedAt: e.ts
        };
      }), s.openChannelMemberCounts = a.open_channels.map(function (e) {
        return {
          channelUrl: e.channel_url,
          participantCount: e.participant_count,
          updatedAt: e.ts
        };
      }), s;
    }
    return n(t, e), t;
  }(t),
  H = function (e) {
    function t(n, t, a) {
      var o,
        E,
        N,
        i,
        _ = this;
      (_ = e.call(this, n, "ADMM", a) || this).message = new u(n, a);
      var l = s.of(n).sdkState;
      return _.isMentioned = r(_.message.mentionType, null !== (N = null !== (o = _.message.mentionedUserIds) && void 0 !== o ? o : null === (E = _.message.mentionedUsers) || void 0 === E ? void 0 : E.map(function (e) {
        return e.userId;
      })) && void 0 !== N ? N : [], l.userId), _.forceUpdateLastMessage = null !== (i = a.force_update_last_message) && void 0 !== i && i, _;
    }
    return n(t, e), t;
  }(t),
  T = function (e) {
    function t(n, t, a) {
      var r,
        N,
        i,
        _,
        l,
        C = this;
      (C = e.call(this, n, "AEDI", a) || this).message = new u(n, a);
      var d = s.of(n).sdkState;
      return C.mentionCountChange = o({
        mentionType: null === (r = a.old_values) || void 0 === r ? void 0 : r.mention_type,
        mentionedUserIds: null !== (i = null === (N = a.old_values) || void 0 === N ? void 0 : N.mentioned_user_ids) && void 0 !== i ? i : []
      }, E({
        mentionType: C.message.mentionType,
        mentionedUserIds: null !== (_ = C.message.mentionedUserIds) && void 0 !== _ ? _ : null === (l = C.message.mentionedUsers) || void 0 === l ? void 0 : l.map(function (e) {
          return e.userId;
        })
      }), d.userId), C;
    }
    return n(t, e), t;
  }(t),
  U = function (e) {
    function t(n, t, a) {
      var s = e.call(this, n, "MRCT", a) || this;
      return s.channelUrl = a.channel_url, s.channelType = a.channel_type, s.event = new _(a), s;
    }
    return n(t, e), t;
  }(t),
  L = function (e) {
    function t(n, t, a) {
      var s = e.call(this, n, "MTHD", a) || this;
      return s.event = new l(n, a), s;
    }
    return n(t, e), t;
  }(t),
  m = function (e) {
    function t(n, t, a) {
      var s = e.call(this, n, "PEDI", a) || this;
      return s.event = new C(n, a), s.status = N(a.poll.status) || a.poll.status, s.channelUrl = a.channel_url, s.channelType = a.channel_type, s;
    }
    return n(t, e), t;
  }(t),
  f = function f() {
    this.onUserMuted = i, this.onUserUnmuted = i, this.onUserBanned = i, this.onUserUnbanned = i, this.onChannelChanged = i, this.onChannelDeleted = i, this.onChannelFrozen = i, this.onChannelUnfrozen = i, this.onOperatorUpdated = i, this.onChannelMemberCountChanged = i, this.onMetaDataCreated = i, this.onMetaDataUpdated = i, this.onMetaDataDeleted = i, this.onMetaCounterCreated = i, this.onMetaCounterUpdated = i, this.onMetaCounterDeleted = i, this.onMessageReceived = i, this.onMessageUpdated = i, this.onMessageDeleted = i, this.onMentionReceived = i, this.onReactionUpdated = i, this.onThreadInfoUpdated = i;
  };
export { H as A, f as B, A as C, p as M, c as O, m as P, U as R, L as T, T as U, d as a };